import { useGetProductSpecialPromotionQuery } from '@/entities/cart/api/cart-api-slice'

type UsePromotionWithProductParams = {
	productId: number
}

export const usePromotionWithProduct = ({ productId }: UsePromotionWithProductParams) => {
	const { data = null, isLoading } = useGetProductSpecialPromotionQuery({ productId }, { skip: !productId })

	return {
		promotion: data,
		isLoading
	}
}
